export default __webpack_public_path__ + "static/media/checked-circle.cfad75a7.svg";